import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpOther from "./../PopUp/PopUpOther";
import PopupArcode from './../PopUp/PopUpArcode';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
import { genURL, gengetURLTEST } from './../_getjson.js';
import { Row, Grid, Col } from "react-bootstrap";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Chacktaxgroup from './../CustomFunction/Taxgroup/Chacktaxgroup'
import ChackAr from './../CustomFunction/Csar/GetAr'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import FullScreenDialog from '../PopUp/FullScreendialogs/FullScreen'
import Moment from 'moment';
require('./../_css/PopUpOther.css');
export default class PopUpMultipletax extends React.Component {

    constructor(props) {
        super(props)
        this.Name = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.CustomerCode = React.createRef();
        this.CustomerName = React.createRef();
        this.Remark = React.createRef();
        this.Before = React.createRef();
        this.Vat = React.createRef();
        this.Ratetax = React.createRef();
        this.Totalmoney = React.createRef();
        this.Totaltax = React.createRef();
        this.state = {
            selected: "0",
            openBackdrop: false,
            Groupdata_txt: "",
            Taxgroup: "",
            autoClose: 3600,
            Docdatepopup: this.props.parm.Docdate,
            col: [],
            recheckedstatus: false
        }
    }
    convertimeps = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    componentDidMount = async () => {
        console.log("componentDidMount", this.props.recheckeddata);


        if (this.props.recheckeddata.length > 0) {
            this.checkCSoutputtax(this.props.recheckeddata)
            this.setState({ recheckedstatus: true })
        } else {
            console.log("this.props.taxgroup", this.props.taxgroup);
            this.Groupdata_code.current.value = this.props.taxgroup
            if (this.props.parm.defult) {
                this.setState({ col: this.props.parm.defult })
                var total = 0.00
                for (let i = 0; i < this.props.parm.defult.length; i++) {
                    if (this.props.parm.defult[i].Taxamount) {
                        total += Number(this.props.parm.defult[i].Taxamount)
                    }
                }
                this.Totaltax.current.value = total.toFixed(2)
            } else {
                this.setRow(10);
            }
            this.setText();
        }
    }
    checkCSoutputtax = async (data) => {
        console.log("checkCSoutputtax", data);
        let url = `csoutputtax/Getcsoutputtax?Tablename=` + this.props.from + `&Docno=` + data[0].DOCNO
        let res = await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            return res
        })
        await console.log("checkCSoutputtax", res);

        let dataitem = []
        let dataitems = []
        let sumtaxamount = 0.00
        if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
                dataitem[i] = {
                    number: i + 1,
                    Taxno: res.data[i].TAXNO,
                    Taxdate: res.data[i].TAXDATE,
                    Arcode: res.data[i].ARCODE,
                    Arname: res.data[i].ARNAME,
                    Remark: res.data[i].REMARK,
                    Beforetax: res.data[i].BEFORETAX,
                    Taxamount: res.data[i].TAXAMOUNT,
                    Totalamount: res.data[i].TOTALAMOUNT,
                    Zerotax: res.data[i].ZEROTAX
                    // Code: this.Groupdata_code.current.value,
                }
                dataitems.push(dataitem[i])

                if (res.data[i].TAXAMOUNT) {
                    sumtaxamount += Number(res.data[i].TAXAMOUNT)
                }
            }
            this.Totaltax.current.value = sumtaxamount.toFixed(2);
            await this.setState({ col: dataitems })
        }
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                number: i + 1,
            }
        }
        this.setState({ col: data });
        setTimeout(() => {
            this.Submit(true)
        }, 200);
    }
    setText = () => {
        var data = this.props.parm
        // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxdata", data);
        if (data !== undefined) {
            this.onAddValue("Groupdata1", data.Groupdata_code, "1");
            this.DeliNumber.current.value = data.DeliNumber
            this.CustomerCode.current.value = data.Code
            this.CustomerName.current.value = data.Name
            this.Remark.current.value = data.Remark
            let sumpersen = 100 + Number(data.TaxPersen)
            let persen = parseFloat((data.Total / sumpersen) * data.TaxPersen).toFixed(2)
            this.Before.current.value = parseFloat(data.Total - persen).toFixed(2)
            this.Vat.current.value = persen
            this.Ratetax.current.value = "0.00"
            this.Totalmoney.current.value = data.Total
            if (this.props.parm.defult === "") {
                this.Totaltax.current.value = "0.00"
            }
        }
    }
    SetRowNull = () => {
        var col = this.state.col;
        var NewCol = [];
        var j = 0;
        for (var i = 0; i < col.length; i++) {
            if (col[i].Taxno) {
                if (col[i].Taxno !== this.DeliNumber.current.value) {
                    NewCol[j] = col[i];
                    NewCol[j].number = j + 1;
                    j++;
                }
            }
        }
        for (var i = j; i < col.length; i++) {
            NewCol[j] = { number: j + 1 };
            j++;
        }
        this.setState({ col: NewCol })
        setTimeout(() => {
            this.Submit(true)
        }, 200);
    };
    SelectSetData = async (type, data) => {
        switch (type) {
            case "Calendar1":
                this.setState({ Docdatepopup: data })
                console.log(data);
                this.Chackdoc()
                break;
            default:
                break;
        }
    }
    onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata1":
                    await Chacktaxgroup(value, "CSTAXGROUP").then(async (result) => {
                        console.log(result);
                        if (result.length > 0) {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result[0].MYNAMETH
                            this.setState({ Groupdata_txt: result[0].MYNAMETH });
                            this.setState({ Taxgroup: result[0].TAXGROUP });
                            this.setState({ Taxformat: result[0].TAXFORMAT });
                            if (Fix !== "1") {
                                this.Chackdoc()
                            }
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.setState({ Taxgroup: "" });
                            this.setState({ Taxformat: "" });
                            this.DeliNumber.current.value = ""
                        }
                    }).catch((err) => {
                        this.Groupdata_code.current.value = ""
                        this.Groupdata.current.value = ""
                        this.setState({ Groupdata_txt: "" });
                        this.setState({ Taxgroup: "" });
                        this.setState({ Taxformat: "" });
                        this.DeliNumber.current.value = ""
                        console.log(err);
                    });
                    break;
                default: break;
            }
        }
    };
    Get_PopUpOther = async (value) => {
        console.log(value);
        this.CloseDialog(false)
        var data = value.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        if (this.state.OtPopupType === "Groupdata1") {
            this.Groupdata_code.current.value = data[0]
            this.Groupdata.current.value = data[1]
            this.setState({ Groupdata_txt: data[1] });
            await this.setState({ Taxgroup: data[2] });
            this.setState({ Taxformat: data[3] });
            this.Chackdoc()
        }
    }
    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type });
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        //ชื่อ
        this.setState({ typeFullScreenDialog: type })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "เลือกรายการ-CSTAXGROUP" })
    };
    setinput = () => {
        this.Groupdata_code.current.value = ""
        this.Groupdata.current.value = ""
        this.setState({ Groupdata_txt: "" });
        this.setState({ Docdatepopup: "" });
        this.DeliNumber.current.value = ""
        this.Before.current.value = "0.00"
        this.Vat.current.value = "0.00"
        this.Ratetax.current.value = "0.00"
        this.Totalmoney.current.value = "0.00"
        // this.Totaltax.current.value = "0.00"
        setTimeout(() => {
            this.Submit(true)
        }, 2000);

    };
    Submit = (e, y) => {
        var listitem = this.state.col

        let resdata = []
        resdata.push(e)
        resdata.push(listitem)
        resdata.push(this.state.Docdatepopup)
        resdata.push(this.Groupdata_code.current.value)
        resdata.push(this.Groupdata.current.value)
        resdata.push(this.DeliNumber.current.value)
        resdata.push(this.CustomerCode.current.value)
        resdata.push(this.CustomerName.current.value)
        resdata.push(this.Remark.current.value)
        this.props.resdata(resdata)
        if (y === '1') {
            this.props.closePopup(false)
        }

    };
    Chackdoc = async () => {
        if (this.state.Taxgroup) {
            var Docdatepopup1 = Moment(this.state.Docdatepopup, 'DD/MM/YYYY').add(-543, "year").format('YYYY-MM-DD')
            var Url = "CSTAXGROUP/Getcoutputtax?Docdate=" + Docdatepopup1 + "&Code=" + this.Groupdata_code.current.value
            console.log("CSTAXGROUP", genURL(Url));
            await axios.get(genURL(Url), { timeout: 60000 }).then((res) => {
                if (res.data.length > 0) {
                    this.DeliNumber.current.value = res.data[0]
                } else {
                    this.DeliNumber.current.value = ""
                }
            }).catch((err) => {
                console.log(err);
                this.DeliNumber.current.value = ""
            });
        }
        await this.Submit(true)
    }
    onSelectRow = (row, col, id) => {
        if (row.Taxno) {
            this.setState({ Docdatepopup: row.Taxdate })
            console.log(row.Code);
            this.onAddValue("Groupdata1", row.Code, "1");
            this.DeliNumber.current.value = row.Taxno
            this.CustomerCode.current.value = row.Arcode
            this.CustomerName.current.value = row.Arname
            this.Remark.current.value = row.Remark
            this.Before.current.value = row.Beforetax
            this.Vat.current.value = row.Taxamount
            this.Ratetax.current.value = row.Zerotax
            this.Totalmoney.current.value = row.Totalamount


            // var sumtaxamount = 0.00
            // for (let j = 0; j < this.state.col.length; j++) {
            //     if (this.state.col[j].Taxamount) {
            //         sumtaxamount += Number(this.state.col[j].Taxamount)
            //     }
            // }
            // this.Totaltax.current.value = sumtaxamount.toFixed(2)


            // this.Totaltax.current.value = row.Totalamount
        }

    }
    Get_PopUparcode = (data1, data2) => {
        this.CloseDialog(false)
        this.CustomerCode.current.value = data1;
        this.CustomerName.current.value = data2;
        setTimeout(() => {
            this.Submit(true)
        }, 200);
    }
    Addtable = async () => {

        if (this.DeliNumber.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกกลุ่มภาษี" })
            return
        }
        if (this.CustomerName.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกข้อมูลลูกค้า" })
            return
        }
        var data = this.state.col
        for (var i = 0; i < data.length && data[i].Taxno; i++) {
            if (data[i].Taxno === this.DeliNumber.current.value) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ใบกำกับภาษีซ้ำ" })
                return
            }
        }
        data[i] = {
            number: i + 1,
            Taxno: this.DeliNumber.current.value,
            Taxdate: this.state.Docdatepopup,
            Arcode: this.CustomerCode.current.value,
            Arname: this.CustomerName.current.value,
            Remark: this.Remark.current.value,
            Beforetax: this.Before.current.value,
            Taxamount: this.Vat.current.value,
            Totalamount: this.Totalmoney.current.value,
            Zerotax: this.Ratetax.current.value,
            Code: this.Groupdata_code.current.value,
        }
        this.setState({ col: data })
        var sumtaxamount = 0.00
        for (let j = 0; j < this.state.col.length; j++) {
            if (this.state.col[j].Taxamount) {
                sumtaxamount += Number(this.state.col[j].Taxamount)
            }
        }
        this.Totaltax.current.value = sumtaxamount.toFixed(2)

        //หลังจากนำข้อมูลเข้าตารางเสร็จ
        //แปลงใบกำกับภาษีใหม่
        setTimeout(() => {
            var order = ""
            var datataxno = ""
            if (this.DeliNumber.current.value) {
                var TAXNO = this.DeliNumber.current.value.split('-')
                var numbertax = Number(TAXNO[2])
                let number = numbertax + 1
                if (number > 0 && number < 10) {
                    order = "00" + number
                    // console.log(order);
                }
                if (number > 9 && number < 100) {
                    order = "0" + number
                    // console.log(order);
                }
                if (number > 99) {
                    order = number
                    // console.log(order);
                }
                datataxno = TAXNO[0] + "-" + TAXNO[1] + "-" + order
            }
            this.DeliNumber.current.value = datataxno
            this.Before.current.value = "0.00"
            this.Vat.current.value = "0.00"
            this.Ratetax.current.value = "0.00"
            this.Totalmoney.current.value = "0.00"
        }, 200);
    }
    onClick = (e) => {
        switch (e.target.name) {
            case "Groupdata1":
                this.Groupdata.current.value = this.Groupdata_code.current.value
                break;
            case "Before":
                let check = this.Before.current.value.split(".")
                if (check[1] === "00") {
                    this.Before.current.value = parseFloat(e.target.value).toFixed(0)
                }
                break;
            case "Vat":
                let check1 = this.Vat.current.value.split(".")
                if (check1[1] === "00") {
                    this.Vat.current.value = parseFloat(e.target.value).toFixed(0)
                }

                break;
            case "Ratetax":
                let check2 = this.Ratetax.current.value.split(".")
                if (check2[1] === "00") {
                    this.Ratetax.current.value = parseFloat(e.target.value).toFixed(0)
                }

                break;
            case "Totalmoney":
                let check3 = this.Totalmoney.current.value.split(".")
                if (check3[1] === "00") {
                    this.Totalmoney.current.value = parseFloat(e.target.value).toFixed(0)
                }

                break;
            case "Totaltax":
                let check4 = this.Totaltax.current.value.split(".")
                if (check4[1] === "00") {
                    this.Totaltax.current.value = parseFloat(e.target.value).toFixed(0)
                }
                break;

            default:
                break;
        }
    }
    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            switch (e.target.name) {
                case "Groupdata1":
                    this.onAddValue("Groupdata1", e.target.value);
                    this.CustomerCode.current.focus()
                    break;
                case "CustomerCode":
                    ChackAr(e.target.value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            this.CustomerName.current.value = data[0]
                        } else {
                            this.CustomerCode.current.value = ""
                            this.CustomerName.current.value = ""
                        }
                    }).catch((err) => {
                        this.CustomerCode.current.value = ""
                        this.CustomerName.current.value = ""
                        console.log(err);
                    });
                    this.CustomerName.current.focus()
                    break;
                case "CustomerName":
                    this.Remark.current.focus()
                    break;
                case "Remark":
                    this.Before.current.focus()
                    break;
                case "Before":
                    var data = this.props.parm
                    console.log(data);
                    // var defultpersen = 0.00
                    // if (data.TaxPersen === '0.00') {
                    //     defultpersen = 7
                    // }else{
                    //     defultpersen = data.TaxPersen
                    // }
                    let persen = parseFloat((e.target.value / 100) * data.TaxPersen).toFixed(2)
                    this.Vat.current.focus()
                    this.Vat.current.value = persen
                    this.Totalmoney.current.value = parseFloat(Number(e.target.value) + Number(persen)).toFixed(2)
                    break;
                case "Vat":
                    this.Ratetax.current.focus()
                    break;
                case "Ratetax":
                    this.Totalmoney.current.focus()
                    break;
                case "Totalmoney":
                    this.Totaltax.current.focus()
                    this.Addtable()
                    break;
                case "Totaltax":
                    this.Totaltax.current.focus()
                    break;

                default:
                    break;
            }
        }
    }
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata1':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case "CustomerCode":
                if (e.target.value === "") {
                    this.CustomerCode.current.value = ""
                    this.CustomerName.current.value = ""
                }
                break;
            case "Before":
                if (e.target.value === "") {
                    this.Before.current.value = parseFloat(0).toFixed(2)
                }
                break;
            case "Vat":
                if (e.target.value === "") {
                    this.Vat.current.value = parseFloat(0).toFixed(2)
                }
                break;
            case "Ratetax":
                if (e.target.value === "") {
                    this.Ratetax.current.value = parseFloat(0).toFixed(2)
                }
                break;
            case "Totalmoney":
                if (e.target.value === "") {
                    this.Totalmoney.current.value = parseFloat(0).toFixed(2)
                }
                break;
            case "Totaltax":
                if (e.target.value === "") {
                    this.Totaltax.current.value = parseFloat(0).toFixed(2)
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        switch (e.target.name) {
            case "Groupdata1":
                this.Groupdata.current.value = this.state.Groupdata_txt;
                break;
            case "Before":
                this.Before.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Vat":
                this.Vat.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Ratetax":
                this.Ratetax.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Totalmoney":
                this.Totalmoney.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Totaltax":
                this.Totaltax.current.value = parseFloat(e.target.value).toFixed(2)
                break;

            default:
                break;
        }
        this.Submit(true)
    }
    Switch_PopupArcode = (e) => {
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" })
    };
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }
    render() {
        const type = this.state.typeFullScreenDialog
        return (
            <div className='popup' onClick={this.onClick} onKeyPress={this.onKeyPress} onChange={this.onChange} onBlur={this.onBlur} >
                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
                    {type === "Groupdata1" ? <PopUpOther closePopup={e => this.CloseDialog(false)} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} userSite={this.state.siteCodeUser} /> : null}
                    {type === "Search_ARCode" ? <PopupArcode closePopup={e => this.CloseDialog(false)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
                </FullScreenDialog>
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"> <i className="fas fa-save" > บันทึกภาษีขาย </i> </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.parm.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div className="DivTable" >
                            <div className="form-inline" hidden={this.state.recheckedstatus}>
                                <div className="form-group mb-2" style={{ marginBottom: '15px !important' }}>
                                    <nav className="navbar TopApp ssss" >
                                        <div className="flex-list">
                                            <ul className="nav navbar-nav navbar-left">
                                                <li><span type="button" className="btn-md" onClick={() => { this.Submit(false, '1') }}>  <i className="fas fa-save"></i> ตกลง </span></li>
                                                <span className="pipe"></span>
                                                <li><span type="button" className=" btn-md" onClick={() => { this.setinput() }}><i className="fas fa-file"></i> รายการใหม่ </span></li>
                                                <span className="pipe"></span>
                                                <li>
                                                    <span type="button" className=" btn-md" onClick={() => { this.setRow(10) }}>
                                                        <i className="fas fa-eraser"></i> ล้างทั้งหมด
                                                    </span>
                                                </li>
                                                <span className="pipe"></span>
                                                <li>
                                                    <span type="button" className=" btn-md" onClick={() => { this.SetRowNull() }}>
                                                        <i className="fas fa-trash-alt"></i>ลบรายการ
                                                    </span>
                                                </li>
                                                <span className="pipe"></span>
                                                <li><span type="button" className=" btn-md" ><i className="fas fa-hammer"></i> Running ใหม่ทั้งหมด</span></li>
                                                <span className="pipe"></span>
                                                {/* <li><span type="button" className=" btn-md" onClick={() => { this.props.resdata() }}><i className="fas fa-door-open"></i> ปิดหน้าจอ</span></li>
                                                <span className="pipe"></span> */}
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                            <br></br>
                            <div className="form-group col-md-12" >
                                <BootstrapTable
                                    data={this.state.col}
                                    height="468"
                                    options={{
                                        onRowClick: this.onSelectRow,
                                        noData: "...."
                                    }}
                                    hover condensed>
                                    <TableHeaderColumn columnClassName="columnAll columnID" className="columnID" expandable={true} dataAlign="center" width="35" dataField='number' dataSort></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Taxno' isKey width="200"><div align="center">ใบกำกับภาษี</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Taxdate' columnTitle width="180"><div align="center">วันที่ใบกำกับ</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Arcode' columnTitle width="180"><div align="center">รหัสลูกหนี้</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Arname' /* dataSort */ width="180" columnTitle> <div align="center">ชื่อผู้ซื้อ/ผู้ใช้บริการ</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Remark' /* dataSort */ width="140" columnTitle> <div align="center">คำอธิบายภาษี</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Beforetax' dataAlign="reight" width="140" columnTitle> <div align="center">ยอดก่อนภาษี</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Taxamount' dataAlign="reight" width="140" columnTitle> <div align="center">ภาษี</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Totalamount' dataAlign="reight" width="140" columnTitle> <div align="center">รวมภาษี</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Zerotax' dataAlign="reight" width="140" columnTitle> <div align="center">อัตราศูนย์</div></TableHeaderColumn>
                                    <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField='Code' width="200" editable={false}><div align="center"></div></TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>

                        <Grid >
                            <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
                                <Row className="show-grid">
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <MaterialUIPickers title="วันที่ใบกำกับ"
                                                DateValue={e => this.SelectSetData("Calendar1", e)}
                                                defaultdate={this.state.Docdatepopup} />
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> กลุ่มภาษี  </span>
                                                    <input type="text" ref={this.Groupdata_code} id="Groupdata_code" name="Groupdata_code" hidden />
                                                    <input id="Groupdata1" type="text" className="form-control " name="Groupdata1" ref={this.Groupdata} />
                                                    <span id="Groupdata1" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdata1")}>
                                                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> ใบกำกับภาษี  </span>
                                                    <input id="DeliNumber" type="text" className="form-control " name="DeliNumber" ref={this.DeliNumber} disabled />
                                                    <span id="iconTaxNumber" className="input-group-addon icon">
                                                        <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> ลูกค้า  </span>
                                                    <input id="CustomerCode" type="text" className="form-control " name="CustomerCode" ref={this.CustomerCode} />
                                                    <span id="iconCustomerCode" className="input-group-addon icon" onClick={() => this.Switch_PopupArcode("Search_ARCode")}>
                                                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={8} md={8} lg={8}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span id="iconCustomerName" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                                    <input id="CustomerName" type="text" className="form-control " name="CustomerName" ref={this.CustomerName} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '5px' }}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> คำอธิบาย  </span>
                                                    <input id="Remark" type="text" className="form-control " name="Remark" ref={this.Remark} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> ยอดก่อนภาษี  </span>
                                                    <input id="Before" type="number" className="form-control Price" name="Before" ref={this.Before} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> ภาษีมูลค่าเพิ่ม  </span>
                                                    <input id="Vat" type="number" className="form-control Price" name="Vat" ref={this.Vat} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> ภาษีอัตราศูนย์  </span>
                                                    <input id="Ratetax" type="number" className="form-control Price" name="Ratetax" ref={this.Ratetax} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> รวมเงินทั้งสิ้น  </span>
                                                    <input id="Totalmoney" type="number" className="form-control Price" name="Totalmoney" ref={this.Totalmoney} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} lg={4}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <span className="input-group-addon"> ยอดรวมภาษี  </span>
                                                    <input id="Totaltax" type="number" className="form-control Price" name="Totaltax" ref={this.Totaltax} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Grid>
                        <Snackbar place="br"
                            color={this.state.color}
                            icon={this.state.icon}
                            autoClose={this.state.autoClose}
                            message={this.state.messagealert}
                            open={this.state.opensnackbar}
                            closeNotification={() => { this.setState({ opensnackbar: false }) }}
                            close />
                    </div>
                </div>
            </div>

        );
    }
}